
import { GlobalController } from 'src/shared/global/GlobalController'
import Danfe from './Danfe.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'danfe',
    component: Danfe,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
